// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__oENs7","box":"Modal_box__sid1V","header":"Modal_header__wWEWH","title":"Modal_title__HnyoY","close":"Modal_close__M1oFK","body":"Modal_body__ZsXZA"};